// extracted by mini-css-extract-plugin
export default {"container":"App_container__ZdBeZ","loader":"App_loader__YDZPi","l20":"App_l20__YZAzM"};